// Shared, dependency-free download-link contract for the marketing funnel.
// Pure module: safe to import from client components, server routes, and tests.

export const ANDROID_APP_ID = "com.bestcoaching.app";

export const ANDROID_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.bestcoaching.app";

export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/ultrack/id6759396564";

export type PlatformTarget = "android" | "ios";

/**
 * Coarse platform detection from a User-Agent string.
 * Returns "ios" for iPhone/iPad/iPod, "android" for Android, else "other".
 */
export function detectPlatformTarget(
  userAgent: string | null | undefined
): PlatformTarget | "other" {
  if (!userAgent) return "other";
  if (/iphone|ipad|ipod/i.test(userAgent)) return "ios";
  if (/android/i.test(userAgent)) return "android";
  return "other";
}

/**
 * Build the Google Play install URL, optionally carrying a Play Install
 * Referrer (utm_source / utm_campaign) so installs are attributable.
 * Omits the referrer entirely when no utm values are supplied.
 * Always returns a valid, absolute Play Store URL.
 */
export function buildAndroidPlayUrl(utm?: {
  utm_source?: string | null;
  utm_campaign?: string | null;
}): string {
  const referrerParts: string[] = [];
  if (utm?.utm_source) {
    referrerParts.push(`utm_source=${utm.utm_source}`);
  }
  if (utm?.utm_campaign) {
    referrerParts.push(`utm_campaign=${utm.utm_campaign}`);
  }
  if (referrerParts.length === 0) {
    return ANDROID_PLAY_URL;
  }
  const referrer = encodeURIComponent(referrerParts.join("&"));
  return `${ANDROID_PLAY_URL}&referrer=${referrer}`;
}
